<template>
  <v-card class="create-nsr-item">
    <v-card-title>
      {{ $t("nsr_item.create_title") }}
    </v-card-title>
    <v-card-text class="d-flex flex-column overflow-auto">
      <v-form ref="form">
        <v-text-field
          outlined
          :label="$t('nsr_item.item_no')"
          v-model="item.item_no"
          :rules="requiredRules"
        ></v-text-field>
        <v-text-field
          outlined
          :label="$t('nsr_item.action_description')"
          v-model="item.action_description"
        ></v-text-field>
        <v-text-field
          outlined
          :label="$t('nsr_item.work_order_no')"
          v-model="item.work_order_no"
        ></v-text-field>
        <v-row>
          <v-col cols="4">
            <v-select
              outlined
              :label="$t('nsr_item.unit_id')"
              :items="unitIdOptions"
              v-model="item.unit_id"
              :rules="requiredRules"
            ></v-select>
          </v-col>
          <v-col cols="8">
            <v-text-field
              outlined
              readonly
              :label="$t('nsr_item.unit')"
              :value="unit"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-text-field
          outlined
          type="number"
          min="0"
          step=".01"
          :label="$t('nsr_item.value')"
          v-model="item.value"
          :rules="requiredRules"
        ></v-text-field>
        <v-row>
          <v-col cols="8">
            <v-text-field
              outlined
              :label="$t('nsr_item.contract_no')"
              v-model="item.contract_no"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-select
              outlined
              clearable
              :label="$t('nsr_item.contract_year')"
              :items="contractYearOptions"
              v-model="item.contract_year"
            ></v-select>
          </v-col>
        </v-row>
        <DatePickerInput
          :label="$t('nsr_item.request_date')"
          :hide-details="false"
          v-model="item.request_date"
        ></DatePickerInput>
        <DatePickerInput
          :label="$t('nsr_item.approval_date')"
          :hide-details="false"
          v-model="item.approval_date"
        ></DatePickerInput>
        <v-text-field
          outlined
          type="number"
          min="0"
          step=".01"
          :label="$t('nsr_item.contractor_claim')"
          v-model="item.contractor_claim"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary" @click="$emit('submit', false)" depressed large>
        {{ $t("cancel") }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        @click="$refs.form.validate() && save()"
        depressed
        large
      >
        {{ $t("ok") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { ref, computed } from "@vue/composition-api/dist/vue-composition-api";
import { ACTION_TYPES } from "@/store/types";
import DatePickerInput from "@/components/DatePickerInput";

export default {
  name: "CreateNsrItemDialog",
  components: { DatePickerInput },
  setup(props, { root, emit }) {
    const requiredRules = ref([
      (value) => !!value || root.$t("rules.required"),
    ]);

    const item = ref({});

    const unitIdOptions = ref([
      { text: "A", value: "A" },
      { text: "B", value: "B" },
      { text: "C", value: "C" },
      { text: "D", value: "D" },
      { text: "E", value: "E" },
    ]);
    const unit = computed(() => {
      if (item.value.unit_id) {
        return {
          A: "M3",
          B: "M2",
          C: "M",
          D: "KG",
          E: "ITEM",
        }[item.value.unit_id];
      }

      return null;
    });
    const contractYearOptions = ref(["A", "B", "C", "D", "E"]);

    const save = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/nsr/create/",
        params: {
          ...item.value,
          unit: unit.value,
        },
      });

      if (response.body.success) {
        emit("submit", true);
      }
    };

    return {
      requiredRules,
      item,
      unitIdOptions,
      unit,
      contractYearOptions,
      save,
    };
  },
};
</script>
<style lang="less">
.create-nsr-item {
  display: flex;
  flex-direction: column;
  height: 90vh;
}
</style>
